import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://unkwavrxdubyheaedwjs.supabase.co';
const supabaseKey = 'sb_publishable_3n07VD7NkSoXUXDdNINyoA_tGf0yuo_';

export const supabase = createClient(supabaseUrl, supabaseKey);
